/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspaceRouteImport } from './routes/workspace'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PromoterRouteImport } from './routes/promoter'
import { Route as LogoLabRouteImport } from './routes/logo-lab'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as HomeRouteImport } from './routes/home'
import { Route as AudienceRouteImport } from './routes/audience'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RRefCodeRouteImport } from './routes/r.$refCode'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminSignupsRouteImport } from './routes/admin.signups'
import { Route as AdminReferralsRouteImport } from './routes/admin.referrals'
import { Route as AdminPromotersRouteImport } from './routes/admin.promoters'
import { Route as AdminLoginsRouteImport } from './routes/admin.logins'
import { Route as AdminCouponsRouteImport } from './routes/admin.coupons'
import { Route as AdminAcquisitionRouteImport } from './routes/admin.acquisition'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin.users.$userId'
import { Route as AdminPromotersPromoterIdRouteImport } from './routes/admin.promoters.$promoterId'

const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PromoterRoute = PromoterRouteImport.update({
  id: '/promoter',
  path: '/promoter',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoLabRoute = LogoLabRouteImport.update({
  id: '/logo-lab',
  path: '/logo-lab',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsRoute = InsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const AudienceRoute = AudienceRouteImport.update({
  id: '/audience',
  path: '/audience',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RRefCodeRoute = RRefCodeRouteImport.update({
  id: '/r/$refCode',
  path: '/r/$refCode',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSignupsRoute = AdminSignupsRouteImport.update({
  id: '/signups',
  path: '/signups',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReferralsRoute = AdminReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPromotersRoute = AdminPromotersRouteImport.update({
  id: '/promoters',
  path: '/promoters',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginsRoute = AdminLoginsRouteImport.update({
  id: '/logins',
  path: '/logins',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCouponsRoute = AdminCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAcquisitionRoute = AdminAcquisitionRouteImport.update({
  id: '/acquisition',
  path: '/acquisition',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminPromotersPromoterIdRoute =
  AdminPromotersPromoterIdRouteImport.update({
    id: '/$promoterId',
    path: '/$promoterId',
    getParentRoute: () => AdminPromotersRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/audience': typeof AudienceRoute
  '/home': typeof HomeRoute
  '/insights': typeof InsightsRoute
  '/login': typeof LoginRoute
  '/logo-lab': typeof LogoLabRoute
  '/promoter': typeof PromoterRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/workspace': typeof WorkspaceRoute
  '/admin/acquisition': typeof AdminAcquisitionRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/logins': typeof AdminLoginsRoute
  '/admin/promoters': typeof AdminPromotersRouteWithChildren
  '/admin/referrals': typeof AdminReferralsRoute
  '/admin/signups': typeof AdminSignupsRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/r/$refCode': typeof RRefCodeRoute
  '/admin/promoters/$promoterId': typeof AdminPromotersPromoterIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/audience': typeof AudienceRoute
  '/home': typeof HomeRoute
  '/insights': typeof InsightsRoute
  '/login': typeof LoginRoute
  '/logo-lab': typeof LogoLabRoute
  '/promoter': typeof PromoterRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/workspace': typeof WorkspaceRoute
  '/admin/acquisition': typeof AdminAcquisitionRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/logins': typeof AdminLoginsRoute
  '/admin/promoters': typeof AdminPromotersRouteWithChildren
  '/admin/referrals': typeof AdminReferralsRoute
  '/admin/signups': typeof AdminSignupsRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/r/$refCode': typeof RRefCodeRoute
  '/admin/promoters/$promoterId': typeof AdminPromotersPromoterIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/audience': typeof AudienceRoute
  '/home': typeof HomeRoute
  '/insights': typeof InsightsRoute
  '/login': typeof LoginRoute
  '/logo-lab': typeof LogoLabRoute
  '/promoter': typeof PromoterRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/workspace': typeof WorkspaceRoute
  '/admin/acquisition': typeof AdminAcquisitionRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/logins': typeof AdminLoginsRoute
  '/admin/promoters': typeof AdminPromotersRouteWithChildren
  '/admin/referrals': typeof AdminReferralsRoute
  '/admin/signups': typeof AdminSignupsRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/r/$refCode': typeof RRefCodeRoute
  '/admin/promoters/$promoterId': typeof AdminPromotersPromoterIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/audience'
    | '/home'
    | '/insights'
    | '/login'
    | '/logo-lab'
    | '/promoter'
    | '/settings'
    | '/signup'
    | '/workspace'
    | '/admin/acquisition'
    | '/admin/coupons'
    | '/admin/logins'
    | '/admin/promoters'
    | '/admin/referrals'
    | '/admin/signups'
    | '/admin/users'
    | '/r/$refCode'
    | '/admin/promoters/$promoterId'
    | '/admin/users/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/audience'
    | '/home'
    | '/insights'
    | '/login'
    | '/logo-lab'
    | '/promoter'
    | '/settings'
    | '/signup'
    | '/workspace'
    | '/admin/acquisition'
    | '/admin/coupons'
    | '/admin/logins'
    | '/admin/promoters'
    | '/admin/referrals'
    | '/admin/signups'
    | '/admin/users'
    | '/r/$refCode'
    | '/admin/promoters/$promoterId'
    | '/admin/users/$userId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/audience'
    | '/home'
    | '/insights'
    | '/login'
    | '/logo-lab'
    | '/promoter'
    | '/settings'
    | '/signup'
    | '/workspace'
    | '/admin/acquisition'
    | '/admin/coupons'
    | '/admin/logins'
    | '/admin/promoters'
    | '/admin/referrals'
    | '/admin/signups'
    | '/admin/users'
    | '/r/$refCode'
    | '/admin/promoters/$promoterId'
    | '/admin/users/$userId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AudienceRoute: typeof AudienceRoute
  HomeRoute: typeof HomeRoute
  InsightsRoute: typeof InsightsRoute
  LoginRoute: typeof LoginRoute
  LogoLabRoute: typeof LogoLabRoute
  PromoterRoute: typeof PromoterRoute
  SettingsRoute: typeof SettingsRoute
  SignupRoute: typeof SignupRoute
  WorkspaceRoute: typeof WorkspaceRoute
  RRefCodeRoute: typeof RRefCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workspace': {
      id: '/workspace'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promoter': {
      id: '/promoter'
      path: '/promoter'
      fullPath: '/promoter'
      preLoaderRoute: typeof PromoterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logo-lab': {
      id: '/logo-lab'
      path: '/logo-lab'
      fullPath: '/logo-lab'
      preLoaderRoute: typeof LogoLabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights': {
      id: '/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof InsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audience': {
      id: '/audience'
      path: '/audience'
      fullPath: '/audience'
      preLoaderRoute: typeof AudienceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$refCode': {
      id: '/r/$refCode'
      path: '/r/$refCode'
      fullPath: '/r/$refCode'
      preLoaderRoute: typeof RRefCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/signups': {
      id: '/admin/signups'
      path: '/signups'
      fullPath: '/admin/signups'
      preLoaderRoute: typeof AdminSignupsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/referrals': {
      id: '/admin/referrals'
      path: '/referrals'
      fullPath: '/admin/referrals'
      preLoaderRoute: typeof AdminReferralsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/promoters': {
      id: '/admin/promoters'
      path: '/promoters'
      fullPath: '/admin/promoters'
      preLoaderRoute: typeof AdminPromotersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/logins': {
      id: '/admin/logins'
      path: '/logins'
      fullPath: '/admin/logins'
      preLoaderRoute: typeof AdminLoginsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/coupons': {
      id: '/admin/coupons'
      path: '/coupons'
      fullPath: '/admin/coupons'
      preLoaderRoute: typeof AdminCouponsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/acquisition': {
      id: '/admin/acquisition'
      path: '/acquisition'
      fullPath: '/admin/acquisition'
      preLoaderRoute: typeof AdminAcquisitionRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/admin/promoters/$promoterId': {
      id: '/admin/promoters/$promoterId'
      path: '/$promoterId'
      fullPath: '/admin/promoters/$promoterId'
      preLoaderRoute: typeof AdminPromotersPromoterIdRouteImport
      parentRoute: typeof AdminPromotersRoute
    }
  }
}

interface AdminPromotersRouteChildren {
  AdminPromotersPromoterIdRoute: typeof AdminPromotersPromoterIdRoute
}

const AdminPromotersRouteChildren: AdminPromotersRouteChildren = {
  AdminPromotersPromoterIdRoute: AdminPromotersPromoterIdRoute,
}

const AdminPromotersRouteWithChildren = AdminPromotersRoute._addFileChildren(
  AdminPromotersRouteChildren,
)

interface AdminUsersRouteChildren {
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminRouteChildren {
  AdminAcquisitionRoute: typeof AdminAcquisitionRoute
  AdminCouponsRoute: typeof AdminCouponsRoute
  AdminLoginsRoute: typeof AdminLoginsRoute
  AdminPromotersRoute: typeof AdminPromotersRouteWithChildren
  AdminReferralsRoute: typeof AdminReferralsRoute
  AdminSignupsRoute: typeof AdminSignupsRoute
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAcquisitionRoute: AdminAcquisitionRoute,
  AdminCouponsRoute: AdminCouponsRoute,
  AdminLoginsRoute: AdminLoginsRoute,
  AdminPromotersRoute: AdminPromotersRouteWithChildren,
  AdminReferralsRoute: AdminReferralsRoute,
  AdminSignupsRoute: AdminSignupsRoute,
  AdminUsersRoute: AdminUsersRouteWithChildren,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AudienceRoute: AudienceRoute,
  HomeRoute: HomeRoute,
  InsightsRoute: InsightsRoute,
  LoginRoute: LoginRoute,
  LogoLabRoute: LogoLabRoute,
  PromoterRoute: PromoterRoute,
  SettingsRoute: SettingsRoute,
  SignupRoute: SignupRoute,
  WorkspaceRoute: WorkspaceRoute,
  RRefCodeRoute: RRefCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
